import withMapList from '../../../../elements/HOC/withMapList'
import ClientsListSelect from '../../../../elements/Select/Client/ClientsSelect'
import React, { Component, Fragment } from 'react'
import { Col, DatePicker, Form, Input, Row, Select } from 'antd'
import { dateVal, strVal } from '../../../../modules/Utils'
import { get, isEmpty } from 'lodash'
import { compose } from 'recompose'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import ProjectType from '../../../../elements/Select/ProjectType'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../elements/HOC/withSort'

const { TextArea } = Input

const DepartmentType = compose(
  withUrlFetch({
    name: 'groups',
    url: 'groups',
    cache: true,
  }),
  withSpinning,
  withSort
)(CustomSelect)

const CategoryType = compose(
  withSelectFetch({ dropdown: 'project', name: 'project' }),
  withSpinning,
  withSubDropdown({ name: 'category' }),
  withSort
)(CustomSelect)

class ProjectDetail extends Component {
  state = {
    selectedCompany: false,
    ServicesSelectCmp: Select,
    ContractsSelectCmp: Select,
  }

  onChangeCompany = (company) => {
    this.setState({ selectedCompany: company })
  }
  onChangeClient = (client) => {
    if (!isEmpty(client)) {
      const owner = client.replace('partners/', '')
      const { selectedCompany } = this.state
      const url = `clients/` + (isEmpty(owner) ? '' : `${owner}`) + `/contracts?company=${selectedCompany}&state=active`
      const ContractsSelectCmp = compose(
        withUrlFetch({
          name: 'clients_contracts',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.setState({ client, ContractsSelectCmp })
    } else {
      this.setState({
        client: '',
        ContractsSelectCmp: Select,
        url: '',
      })
    }
  }
  onChangeContract = (contract) => {
    if (!isEmpty(contract)) {
      const ServicesSelectCmp = compose(
        withUrlFetch({
          name: 'clients',
          url: contract,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSubDropdown({ name: 'rates' }),
        withMapList(({ name, ...r }) => ({
          name: `${strVal(r, 'product.name')} / ${name}`,
          ...r,
        })),
        withSort
      )(CustomSelect)
      this.setState({ contract, ServicesSelectCmp })
    } else {
      this.setState({
        ServicesSelectCmp: Select,
      })
    }
  }

  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { ContractsSelectCmp } = this.state
    const { project, onChangeCat, onChangeTemplate, internal, sales, templatesLists } = this.props
    const TemplateSelect = compose(
      withData({
        data: templatesLists.group.template,
      })
    )(CustomSelect)

    return (
      <Form className="steps-content">
        <Row>
          <Col span={12}>
            <Form.Item label="Project Title" {...formItemLayoutRow}>
              {getFieldDecorator('project.title', {
                initialValue: strVal(project, 'project.title'),
                rules: [{ required: true, message: "project Title can't be empty " }],
              })(<Input placeholder="Title" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Project Type" {...formItemLayoutRow}>
              {getFieldDecorator('project.projectType', {
                initialValue: get(project, 'project.projectType'),
                rules: [
                  {
                    required: true,
                    message: "Contract Type can't be empty ",
                  },
                ],
              })(<ProjectType />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Company" {...formItemLayoutRow}>
              {getFieldDecorator('project.company._id', {
                initialValue: get(project, 'project.company._id'),
                rules: [{ required: true, message: 'Please Select a Company!' }],
              })(<OrganisationsSelect placeholder={'Select a Company'} onChange={this.onChangeCompany} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Category" {...formItemLayoutRow}>
              {getFieldDecorator('project.category', {
                initialValue: get(project, 'project.category'),
                rules: [
                  {
                    required: true,
                    message: "Project category can't be empty ",
                  },
                ],
              })(<CategoryType onChange={onChangeCat} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {this.props.form.getFieldValue('project.company._id') && (
            <Col span={12}>
              <Form.Item {...formItemLayoutRow} label={'Cost Center'}>
                {getFieldDecorator('project.cost._id', {
                  initialValue: get(project, 'project.cost._id'),
                  rules: [
                    {
                      type: 'array',
                      required: true,
                      message: "Cost can't be empty",
                    },
                  ],
                })(
                  <CentersCascader
                    style={{ width: '250%' }}
                    key={this.props.form.getFieldValue('project.company._id')}
                    category={'Profit'}
                    company={this.props.form.getFieldValue('project.company._id')}
                  />
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          {sales && (
            <Fragment>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Select a Client'}>
                  {getFieldDecorator('project.client', {
                    initialValue: get(project, 'project.client'),
                    rules: [{ required: true, message: 'Please Select a Client!' }],
                  })(
                    <ClientsListSelect
                      placeholder={'Select a Client'}
                      keyAtr={'_id'}
                      valueAtr={'fn'}
                      disabled={!this.props.form.getFieldValue('project.company._id')}
                      onChange={this.onChangeClient}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Sales Contract" {...formItemLayoutRow}>
                  {getFieldDecorator('project.salesContract', {
                    initialValue: get(project, 'project.salesContract'),
                    rules: [
                      {
                        required: true,
                        message: "Sales Contract Type can't be empty ",
                      },
                    ],
                  })(
                    <ContractsSelectCmp
                      onChange={this.onChangeContract}
                      keyAtr={'_id'}
                      valueAtr={'title'}
                      disabled={!this.props.form.getFieldValue('project.company._id')}
                      placeholder={'Contracts Account'}
                    />
                  )}
                </Form.Item>
              </Col>
            </Fragment>
          )}
          {internal && (
            <Col span={12}>
              <Form.Item label="Department" {...formItemLayoutRow}>
                {getFieldDecorator('project.department', {
                  initialValue: get(project, 'project.department'),
                  rules: [
                    {
                      required: true,
                      message: "Sales Contract Type can't be empty ",
                    },
                  ],
                })(<DepartmentType keyAtr={'_id'} valueAtr={'name'} placeholder="Department" />)}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Start Date" {...formItemLayoutRow}>
              {getFieldDecorator('project.startDate', {
                initialValue: dateVal(project, 'project.startDate'),
                rules: [
                  {
                    required: true,
                    message: "Start Date can't be empty ",
                  },
                ],
              })(
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder="Contract Date"
                  disabledDate={this.disabledStartDate}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="End Date (Expected)" {...formItemLayoutRow}>
              {getFieldDecorator('project.endDate', {
                initialValue: dateVal(project, 'project.endDate'),
              })(<DatePicker style={{ width: '100%' }} placeholder="End Date" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayoutRow} label={'Project TemplateSelect'}>
              {getFieldDecorator('project.template', {
                initialValue: get(project, 'project.template'),
              })(<TemplateSelect onChange={onChangeTemplate} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Description" {...formItemLayoutRow}>
              {getFieldDecorator('project.description', {
                initialValue: get(project, 'project.description'),
              })(<TextArea placeholder="Description" rows={4} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(ProjectDetail)
